import React, { Component } from "react";

import AsyncSelect from 'react-select/lib/Async';
import * as locationHelpers from "../../../../../helpers/locationHelpers";

const getPredictions = ( inputValue ) => {
    const options = [];

    return locationHelpers.getGoogleLocationsAutocomplete( inputValue ).then( ( data ) => {

        data.data && data.data.predictions && data.data.predictions.map( option =>
            options.push( { value: option.place_id, label: option.description } )
        );
        return options;
    });
};

const promiseOptions = inputValue =>
    new Promise(resolve => {
        setTimeout(() => {
            resolve(getPredictions(inputValue));
        }, 1000);
    });

export default class LocationInput extends Component {

    render() {
        const { name, isMulti, values, handleChange } = this.props;
        return (
            <div>
                <AsyncSelect
                   name={name}
                   isMulti={isMulti}
                   loadOptions={ promiseOptions }
                   placeholder={'Select...'}
                   defaultOptions={ false }
                   noOptionsMessage={ () => 'Start typing in field to see options' }
                   onChange={ (value) => handleChange(value, name) }
                   value={values}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// src/client/components/site/features/account/location/LocationInput.js